import React, { useState } from "react";
import { Calendar } from "lucide-react";
import { useSelector } from "react-redux";

const EditPurchaseModal = ({ purchase, onSave, onCancel }) => {
  const { isPartsURL, isAccessoriesURL } = useSelector((state) => state.domain);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    vendor: purchase?.vendor_name || "",
    product: purchase?.product_name || "",
    category: purchase?.category_name || "",
    date: purchase?.created_at
      ? new Date(purchase.created_at).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0],
    buyPrice: purchase?.buying_price || "",
    sellPrice: purchase?.selling_price || "",
    quantity: purchase?.initial_quantity || purchase?.available_qty || "",
    uniqueId: purchase?.unique_id || "",
    status: purchase?.status || "Active",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "sellPrice") {
      const numericValue = parseFloat(value);
      if (numericValue < 0) return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const apiData = {
      selling_price: parseFloat(form.sellPrice),
    };

    try {
      await onSave(apiData);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-purchase-modal-overlay">
      <div className="add-purchase-modal noscrollbar">
        <div className="add-purchase-modal-header">
          <h2 className="add-purchase-modal-title">Edit Purchase</h2>
          <p className="add-purchase-modal-subtitle">
            Update purchase information
          </p>
        </div>

        <form onSubmit={handleSubmit} className="add-purchase-modal-form">
          <div className="add-purchase-modal-body">
            {/* Product Display (Read-only) */}
            <div className="purchases-form-group">
              <label className="purchases-form-label">Product</label>
              <div className="purchases-form-input purchases-readonly-input">
                {form.product || "No product selected"}
              </div>
            </div>

            {/* Date Display (Read-only) */}
            <div className="purchases-form-group">
              <label className="purchases-form-label">Date</label>
              <div className="purchases-date-input-container">
                <Calendar size={16} className="purchases-date-icon" />
                <div className="purchases-date-input purchases-readonly-input no-right-icon">
                  {form.date}
                </div>
              </div>
            </div>

            {/* Amount and Quantity Row */}
            <div className="purchases-form-row">
              <div className="purchases-form-group">
                <label className="purchases-form-label">Buy Price</label>
                <div className="purchases-form-input purchases-readonly-input">
                  €{form.buyPrice || "0.00"}
                </div>
              </div>
              <div className="purchases-form-group">
                <label className="purchases-form-label">Sell Price</label>
                <input
                  type="number"
                  className={`${
                    isPartsURL
                      ? "purchases-form-input-parts"
                      : isAccessoriesURL
                      ? "purchases-form-input-acc"
                      : "purchases-form-input"
                  }`}
                  name="sellPrice"
                  value={form.sellPrice}
                  onChange={handleChange}
                  placeholder="Enter sell price"
                  step="0.01"
                  min="0"
                  required
                />
              </div>
            </div>

            {/* quantity */}
            <div className="purchases-form-group">
              <label className="purchases-form-label">Quantity</label>
              <div className="purchases-form-input purchases-readonly-input">
                {form.quantity || "0"}
              </div>
            </div>

            {/*Unique Id*/}
            <div className="purchases-form-group">
              <label className="purchases-form-label">Unique Id</label>
              <div className="purchases-form-input purchases-readonly-input">
                {form.uniqueId || ""}
              </div>
            </div>
          </div>

          <div className="add-purchase-modal-footer">
            <button
              type="button"
              className="purchases-cancel-btn"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`${
                isPartsURL
                  ? "purchases-submit-btn-parts"
                  : isAccessoriesURL
                  ? "purchases-submit-btn-acc"
                  : "purchases-submit-btn"
              }`}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Purchase"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPurchaseModal;
